import axios from 'axios';
import store from '@/store'
import router from '@/router'
import APIUrl from './api.url' // 引入api.url.js

 //判断是否为生产环境
if (process.env.NODE_ENV == 'development') {
  axios.defaults.baseURL =  'https://zkapi.dafangongkao.com';
}else{
  axios.defaults.baseURL = APIUrl.baseURL;
}
//设置请求超时时间
axios.defaults.timeout = 10000;
//设置POST请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;';

// http response 拦截器
// ajax请求回调之前拦截 对请求返回的信息做统一处理 比如error为401无权限则跳转到登陆界面
axios.interceptors.response.use(
  response => {
    if(response.data.code == -2){
      router.replace({
        path: '/login'
      })
    }
    return response
  },
  error => {
    // console.log(error,'error');
    return Promise.reject(error)
  }
)

export default axios // 这句千万不能漏下！！！


/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: {
        ...params,
        jwt_token: store.state.jwt_token,
        source_type: 'wechat'
      }
    }).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err.data)
    })
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, {
        ...params,
        jwt_token: store.state.jwt_token,
        source_type: 'wechat'
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}



// WEBPACK FOOTER //
// ./src/api/request.js